import { Record } from "immutable";

import createFromJS from "../../../createFromJS";

export const SplitConstraintsRecord = Record({
  hasDivider: false,
  dividerVisible: false,
  canResize: false,
  canCollapse: false,
  minSize: 0,
  maxSize: Number.MAX_SAFE_INTEGER,
  preferredSize: 0,
  defaultSize: 1,
  collapseSize: 0
});

createFromJS.registerCallback("SplitConstraintsRecord", createFromJS.createPrimitiveCallback(SplitConstraintsRecord));
